import { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { SessionPanel } from './components/SessionPanel';
import { TopologyGraph } from './components/TopologyGraph';
import { DetailPanel } from './components/DetailPanel';
import { StatusBar } from './components/StatusBar';
import { AnomalyToast } from './components/AnomalyToast';
import { useWebSocket } from './hooks/useWebSocket';
import { useSessionStore } from './store/sessionStore';
import './styles/global.css';
import './App.css';

export default function App() {
  useWebSocket();

  // Hash-based routing: #session/{id}
  useEffect(() => {
    function handleHashChange() {
      const hash = window.location.hash;
      const match = hash.match(/^#session\/(.+)$/);
      if (match) {
        useSessionStore.getState().selectSession(match[1]);
      }
    }
    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="app">
      <TopBar />
      <div className="app-body">
        <SessionPanel />
        <main className="app-main">
          <TopologyGraph />
        </main>
        <DetailPanel />
      </div>
      <StatusBar />
      <AnomalyToast />
    </div>
  );
}
